import type { HeroStats } from "@/components/landing/Hero/types";

interface HeroStatsRowProps {
	stats: HeroStats;
}

function HeroStatsRow(prop: HeroStatsRowProps) {
	const { stats } = prop;
	const hasRevenue = Boolean(stats.revenueValue);
	return (
		<dl
			className={
				hasRevenue ? "mt-8 grid max-w-xl grid-cols-3 gap-3" : "mt-8 grid max-w-md grid-cols-2 gap-3"
			}
		>
			<div className="rounded-2xl border border-border bg-surface/70 p-4 backdrop-blur">
				<dt className="text-xs font-medium uppercase tracking-wide text-(--brand-1)">
					{stats.storesLabel}
				</dt>
				<dd className="mt-1 text-2xl font-bold">{stats.storesValue}</dd>
			</div>
			<div className="rounded-2xl border border-border bg-surface/70 p-4 backdrop-blur">
				<dt className="text-xs font-medium uppercase tracking-wide text-(--brand-1)">
					{stats.ordersLabel}
				</dt>
				<dd className="mt-1 text-2xl font-bold">{stats.ordersValue}</dd>
			</div>
			{hasRevenue && (
				<div className="rounded-2xl border border-border bg-surface/70 p-4 backdrop-blur">
					<dt className="text-xs font-medium uppercase tracking-wide text-(--brand-1)">
						{stats.revenueLabel}
					</dt>
					<dd className="mt-1 text-2xl font-bold">{stats.revenueValue}</dd>
				</div>
			)}
		</dl>
	);
}

export default HeroStatsRow;
